import React, {useState} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import {Link} from 'react-router-dom';
import {t} from '../../services/i18nHandler';

function SidebarNavItem({
  data: {
    disabled, iconComponent: IconComponent, text, route, indent, submenu = [],
  },
  quantity,
  active,
}) {
  const [hideSubmenu, setHideSubmenu] = useState(true);

  return (
    <li
      key={text}
      className={cl('sidebar-nav_item', {
        active,
        disabled,
        indent,
      })}
    >
      <div className="sidebar-nav_link_wrap">
        <Link to={route} className="sidebar-nav_link">
          <div className="sidebar-nav_item-icon">
            {IconComponent ? <IconComponent /> : null}
          </div>
          <span>{t(text)}</span>
        </Link>
        {!!quantity && (<span className="span-quantity">{quantity}</span>)}
        {disabled && (<div className="soon" />)}
        {!!submenu.length && (
          <div
            role="button"
            className="submenu-arrow"
            onClick={() => setHideSubmenu(!hideSubmenu)}
          >
            <i
              className={cl('fa', {
                'fa-angle-down': hideSubmenu,
                'fa-angle-up': !hideSubmenu,
              })}
            />
          </div>
        )}
      </div>
      {!!submenu.length && !hideSubmenu && (
        <div className="sidebar-nav_link_submenu">
          {submenu.map((submenuItem) => {
            const SubmenuIcon = submenuItem.iconComponent;
            return (
              <div className="sidebar-nav_link_wrap">
                <Link to={submenuItem.route} className="sidebar-nav_link">
                  <div className="sidebar-nav_item-icon">
                    {SubmenuIcon && (<SubmenuIcon />)}
                  </div>
                  <span>{t(submenuItem.text)}</span>
                </Link>
                {!!submenuItem.quantity && (<span className="span-quantity">{submenuItem.quantity}</span>)}
                {submenuItem.disabled && (<div className="soon" />)}
              </div>
            );
          })}
        </div>
      )}
    </li>
  );
}

SidebarNavItem.defaultProps = {
  data: {},
  active: false,
};

SidebarNavItem.propTypes = {
  data: PropTypes.shape({}),
  active: PropTypes.bool,
};

export default SidebarNavItem;
